import { useRef, useState, useContext } from "react";
import { Link } from "react-router-dom";

// material-ui
import { useTheme } from "@mui/material/styles";
import {
  // Button,
  Box,
  // CardMedia,
  ClickAwayListener,
  Grid,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  Paper,
  Popper,
  Stack,
  Typography,
  Dialog
} from "@mui/material";

import Info from "../../../../pages/App_Aplicacion/Soporte/index";
// project-imports
import AuthContext from "../../../../contexts/JWTContext";
import MainCard from "components/MainCard";
import Dot from "components/@extended/Dot";
import IconButton from "components/@extended/IconButton";
import Transitions from "components/@extended/Transitions";
import { PopupTransition } from "components/@extended/Transitions";
// import AnimateButton from 'components/@extended/AnimateButton';
import { DRAWER_WIDTH } from "config";

// assets
import { Category2 } from "iconsax-react";
import cardBack from "assets/images/widget/img-dropbox-bg.svg";
// import imageChart from 'assets/images/mega-menu/chart.svg';
import { useNavigate } from "react-router-dom";
// types
import { ThemeMode } from "types/config";
import { swN } from "../../../../pages/App_UI/Notificacion";

// ==============================|| HEADER CONTENT - MEGA MENU SECTION ||============================== //

const MegaMenuSection = () => {
  const context = useContext(AuthContext);
  const theme = useTheme();

  const anchorRef = useRef<any>(null);
  const [open, setOpen] = useState(false);
  const [showpopup, setshowpopup] = useState<boolean>(false);
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: MouseEvent | TouchEvent) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const iconBackColorOpen =
    theme.palette.mode === ThemeMode.DARK ? "secondary.200" : "secondary.200";
  const iconBackColor =
    theme.palette.mode === ThemeMode.DARK
      ? "background.default"
      : "secondary.100";

  const navigate = useNavigate();
  const ClodePopup = (row: any) => {
    // ClearForm();
    // setform((prevForm) => ({
    //   ...prevForm,
    //   tipoOP: "Add"
    // }));
    setshowpopup(!showpopup);
  };
  const handleClickDefault = (e: any) => {
    const buttonId = e.currentTarget.id;

    sessionStorage.setItem("aduanainfo", buttonId);
    setOpen(false);
    navigate(`/${buttonId}`);
  };

  const handleClick = (e: any) => {
    const buttonId = e.currentTarget.id;
    context?.setTransportistaInfo({ aduana: buttonId });
    sessionStorage.setItem("aduanainfo", `${buttonId}`);
    setshowpopup(!showpopup);
  };
  const handleClicCreditos = (e: any) => {
    swN(
      "Grid",
      sessionStorage.getItem("transportistaRazonSocial") || "",
      "warning",
      ` Creditos (${sessionStorage.getItem("Creditos")}) `,
      () => {
        // setshowpopup(!showpopup);
      }
    );
    setOpen(false);
  };

  return (
    <>
      <Dialog
        id="modalAddForm"
        // fullScreen
        maxWidth="md"
        TransitionComponent={PopupTransition}
        keepMounted={true}
        fullWidth
        onClose={ClodePopup}
        open={showpopup}
        sx={{ "& .MuiDialog-paper": { p: 0 }, transition: "transform 1025ms" }}
        aria-describedby="alert-dialog-slide-description"
      >
        <Info />
      </Dialog>
      <Box sx={{ flexShrink: 0, ml: 0.75 }}>
        <IconButton
          color="secondary"
          variant="light"
          aria-label="open profile"
          ref={anchorRef}
          aria-controls={open ? "profile-grow" : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
          size="large"
          sx={{
            color: "secondary.main",
            bgcolor: open ? iconBackColorOpen : iconBackColor,
            ml: { xs: 0, lg: -2 },
            p: 1
          }}
        >
          <Category2 variant="Bulk" size={22} />
        </IconButton>
        <Popper
          placement="bottom"
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          transition
          disablePortal
          popperOptions={{
            modifiers: [
              {
                name: "offset",
                options: {
                  offset: [-180, 9]
                }
              }
            ]
          }}
        >
          {({ TransitionProps }) => (
            <Transitions
              type="grow"
              position="top"
              in={open}
              {...TransitionProps}
            >
              <Paper
                sx={{
                  boxShadow: theme.customShadows.z1,
                  minWidth: 750,
                  width: {
                    md: `calc(100vw - 100px)`,
                    lg: `calc(100vw - ${DRAWER_WIDTH + 100}px)`,
                    xl: `calc(100vw - ${DRAWER_WIDTH + 140}px)`
                  },
                  maxWidth: 1024,
                  borderRadius: 1.5
                }}
              >
                <ClickAwayListener onClickAway={handleClose}>
                  <MainCard elevation={0} border={false} content={false}>
                    <Grid container>
                      <Grid
                        item
                        xs={4}
                        sx={{
                          color: "common.white",
                          bgcolor:
                            theme.palette.mode === ThemeMode.DARK
                              ? "primary.400"
                              : "primary.darker",
                          position: "relative",
                          "&:after": {
                            content: '""',
                            backgroundImage: `url(${cardBack})`,
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            zIndex: 1,
                            opacity: 0.5,
                            backgroundPosition: "bottom right",
                            backgroundSize: "100%",
                            backgroundRepeat: "no-repeat"
                          }
                        }}
                      >
                        <Box
                          sx={{ p: 4.5, pb: 3, position: "inherit", zIndex: 2 }}
                        >
                          <Stack sx={{ color: "background.paper" }}>
                            <Typography
                              variant="h2"
                              sx={{ fontSize: "1.875rem", mb: 1 }}
                            >
                              SIM@
                            </Typography>
                            <Typography variant="h6">
                              Documentación del manifiesto de importación de ACE
                            </Typography>
                            <Stack
                              direction="row"
                              justifyContent="space-between"
                              alignItems="flex-end"
                              sx={{ mt: -1 }}
                            >
                              {/* <AnimateButton>
                              <Button
                                variant="contained"
                                color="secondary"
                                sx={{
                                  bgcolor: 'background.paper',
                                  color: 'text.primary',
                                  '&:hover': { bgcolor: 'background.paper', color: 'text.primary' },
                                  zIndex: 2
                                }}
                                endIcon={<ArrowRight3 variant="Bulk" color={theme.palette.primary.main} />}
                                component={Link}
                                to="/components-overview/buttons"
                                target="_blank"
                              >
                                View All
                              </Button>
                            </AnimateButton> */}
                              {/* <CardMedia component="img" src={imageChart} alt="Chart" sx={{ mr: -2.5, mb: -2.5, width: 124 }} /> */}
                            </Stack>
                          </Stack>
                        </Box>
                      </Grid>
                      <Grid item xs={8}>
                        <Box
                          sx={{
                            p: 4,
                            "& .MuiList-root": {
                              pb: 0
                            },
                            "& .MuiListSubheader-root": {
                              p: 0,
                              pb: 1.5
                            },
                            "& .MuiListItemButton-root": {
                              p: 0.5,
                              "&:hover": {
                                background: "transparent",
                                "& .MuiTypography-root": {
                                  color: "primary.main"
                                }
                              }
                            },
                            "& .MuiListItemIcon-root": {
                              minWidth: 16
                            }
                          }}
                        >
                          <Grid container spacing={6}>
                            <Grid item xs={4}>
                              <List
                                component="nav"
                                aria-labelledby="nested-list-user"
                                subheader={
                                  <ListSubheader id="nested-list-user">
                                    <Typography
                                      variant="subtitle1"
                                      color="textPrimary"
                                    >
                                      Sistema
                                    </Typography>
                                  </ListSubheader>
                                }
                              >
                                <ListItemButton
                                  disableRipple
                                  component={Link}
                                  to="/Inicio"
                                  id="Inicio"
                                  onClick={handleClickDefault}
                                >
                                  <ListItemIcon>
                                    <Dot
                                      size={6}
                                      color="secondary"
                                      variant="outlined"
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Avisos" />
                                </ListItemButton>
                                <ListItemButton
                                  disableRipple
                                  // component={Link}
                                  // to="#"
                                  title="Documentacion"
                                  onClick={handleClicCreditos}
                                >
                                  <ListItemIcon>
                                    <Dot
                                      size={6}
                                      color="secondary"
                                      variant="outlined"
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Créditos Disponibles" />
                                </ListItemButton>
                                <ListItemButton
                                  disableRipple
                                  component={Link}
                                  to="/auth/reset-password"
                                >
                                  <ListItemIcon>
                                    <Dot
                                      size={6}
                                      color="secondary"
                                      variant="outlined"
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Reset Password" />
                                </ListItemButton>

                                <ListItemButton
                                  disableRipple
                                  component={Link}
                                  to="/Documentacion"
                                  title="Documentacion"
                                  id="Documentacion"
                                  onClick={handleClickDefault}
                                >
                                  <ListItemIcon>
                                    <Dot
                                      size={6}
                                      color="secondary"
                                      variant="outlined"
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Documentación" />
                                </ListItemButton>
                              </List>
                            </Grid>
                            <Grid item xs={4}>
                              <List
                                component="nav"
                                aria-labelledby="nested-list-user"
                                subheader={
                                  <ListSubheader id="nested-list-user">
                                    <Typography
                                      variant="subtitle1"
                                      color="textPrimary"
                                    >
                                      Contactanos
                                    </Typography>
                                  </ListSubheader>
                                }
                              >
                                <ListItemButton
                                  disableRipple
                                  component={Link}
                                  to="#"
                                  onClick={handleClick}
                                  id="NL"
                                >
                                  <ListItemIcon>
                                    <Dot
                                      size={6}
                                      color="secondary"
                                      variant="outlined"
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Nuevo Laredo" />
                                </ListItemButton>
                                <ListItemButton
                                  disableRipple
                                  component={Link}
                                  to="#"
                                  id="CJ"
                                  onClick={handleClick}
                                >
                                  <ListItemIcon>
                                    <Dot
                                      size={6}
                                      color="secondary"
                                      variant="outlined"
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Cd Juarez. Chihuahua" />
                                </ListItemButton>
                                <ListItemButton
                                  disableRipple
                                  component={Link}
                                  to="#"
                                  id="NG"
                                  onClick={handleClick}
                                  // onClick={handleClickNG}
                                >
                                  <ListItemIcon>
                                    <Dot
                                      size={6}
                                      color="secondary"
                                      variant="outlined"
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Nogales, Sonora" />
                                </ListItemButton>
                                <ListItemButton
                                  disableRipple
                                  component={Link}
                                  to="#"
                                  // onClick={handleClickPN}
                                  id="PN"
                                  onClick={handleClick}
                                >
                                  <ListItemIcon>
                                    <Dot
                                      size={6}
                                      color="secondary"
                                      variant="outlined"
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Piedras Negras, Coahuila" />
                                </ListItemButton>
                                <ListItemButton
                                  disableRipple
                                  component={Link}
                                  to="#"
                                  // onClick={handleClickTJ}
                                  id="TJ"
                                  onClick={handleClick}
                                >
                                  <ListItemIcon>
                                    <Dot
                                      size={6}
                                      color="secondary"
                                      variant="outlined"
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Tijuana, Baja California" />
                                </ListItemButton>
                                <ListItemButton
                                  disableRipple
                                  component={Link}
                                  to="#"
                                  // onClick={handleClickRN}
                                  id="RN"
                                  onClick={handleClick}
                                >
                                  <ListItemIcon>
                                    <Dot
                                      size={6}
                                      color="secondary"
                                      variant="outlined"
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Reynosa, Tamaulipas" />
                                </ListItemButton>
                                <ListItemButton
                                  disableRipple
                                  component={Link}
                                  to="#"
                                  // onClick={handleClickMT}
                                  id="MT"
                                  onClick={handleClick}
                                >
                                  <ListItemIcon>
                                    <Dot
                                      size={6}
                                      color="secondary"
                                      variant="outlined"
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Matamoros, Tamaulipas" />
                                </ListItemButton>
                              </List>
                            </Grid>
                            {/* <Grid item xs={4}>
                            <List
                              component="nav"
                              aria-labelledby="nested-list-user"
                              subheader={
                                <ListSubheader id="nested-list-user">
                                  <Typography variant="subtitle1" color="textPrimary">
                                    SAAS Pages
                                  </Typography>
                                </ListSubheader>
                              }
                            >
                              <ListItemButton disableRipple component={Link} target="_blank" to="/maintenance/404">
                                <ListItemIcon>
                                  <Dot size={6} color="secondary" variant="outlined" />
                                </ListItemIcon>
                                <ListItemText primary="404 Error" />
                              </ListItemButton>
                              <ListItemButton disableRipple component={Link} target="_blank" to="">
                                <ListItemIcon>
                                  <Dot size={6} color="secondary" variant="outlined" />
                                </ListItemIcon>
                                <ListItemText primary="Landing" />
                              </ListItemButton>
                            </List>
                          </Grid> */}
                          </Grid>
                        </Box>
                      </Grid>
                    </Grid>
                  </MainCard>
                </ClickAwayListener>
              </Paper>
            </Transitions>
          )}
        </Popper>
      </Box>
    </>
  );
};

export default MegaMenuSection;
